module.exports = __webpack_public_path__ + "img/welding-11.ad3e62a3.jpg";